module.exports = __webpack_public_path__ + "static/media/upload_photo.d8526aae.webp";